/**
 * Defines browser compatibility by checking if required functionality is available.
 *
 * @param {Window} window A reference to the main frame's window object.
 */
function BrowserCheck(window) {
  this.window = window
}

BrowserCheck.prototype.isCompatible = function() {
  if (this._isCompatible !== undefined) {
    return this._isCompatible
  }

  this._isCompatible =
    !!this.window.navigator &&
    !!this.window.navigator.userAgent &&
    !this.isSafari5(this.window.navigator.userAgent) &&
    !!this.window.addEventListener &&
    !!this.window.Object.keys &&
    !!this.window.XMLHttpRequest &&
    !!this.window.document.body &&
    !!this.window.document.body.classList &&
    !!this.window.document.body.classList.contains

  return this._isCompatible
}

BrowserCheck.prototype.isSafari5 = function(userAgent) {
  try {
    if (userAgent.indexOf('Safari') === -1) {
      return false
    }
    var versionOffset = userAgent.indexOf('Version')
    if (versionOffset === -1) {
      return false
    }
    var safariVersion = parseInt(userAgent.substring(versionOffset + 8).split(' ')[0], 10)

    return safariVersion === 5
  } catch (exception) {
    return false
  }
}

export default BrowserCheck
